import { createRouter, createWebHistory } from 'vue-router';
import langData from '@/assets/lang.json';

const routes = [
  {
    path: '/MoveinGuideMessage',
    name: 'MoveinGuideMessage',
    component: () => import('../views/AboutGuide.vue'),
    meta: {
      title: '案内内容確認ページ',
    },
  },
  {
    path: '/ServiceGuideMessage',
    name: 'ServiceGuideMessage',
    component: () => import('../views/AboutService.vue'),
    meta: {
      title: '案内詳細',
    },
  },
  {
    path: '/Outage',
    name: 'Outage',
    component: () => import('../views/Outage.vue'),
    meta: {
      title: '解約代行依頼',
    },
  },
  {
    path: '/contactForm',
    name: 'contactForm',
    component: () => import('../views/ContactForm.vue'),
    meta: {
      title: '外国人用のお問い合わせフォーム',
      titleKey: 'form.title',
    },
  },
  {
    path: '/form',
    name: 'Form',
    component: () => import('../views/Form.vue'),
    meta: {
      title: '外国人用のフォーム',
      titleKey: 'form.title',
    },
  },
  {
    path: '/thanks',
    name: 'Thanks',
    component: () => import('../views/Thanks.vue'),
    meta: {
      title: '申し込み完了ページ',
      titleKey: 'thanks.title',
    },
  },
  {
    path: '/OutageGuidePage',
    name: 'OutageGuidePage',
    component: () => import('../views/AboutOutage.vue'),
    meta: {
      title: '解約代行依頼について',
    },
  },
  {
    path: '/reservationForm',
    name: 'ReservationForm',
    component: () => import('../views/ReserveForm.vue'),
    meta: {
      title: '連絡希望日時予約フォーム',
    },
  },
  {
    path: '/notfound',
    name: 'NotFound',
    component: () => import('../views/NotFound.vue'),
    meta: {
      title: 'ページが見つかりません',
    },
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/notfound',
  },
];
// const DEFAULT_TITLE = "案内内容確認ページ";
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.afterEach(to => {
  if (to.name === 'Thanks' || to.name === 'Form' || to.name === 'contactForm') {
    const queryLang = to.query.lang || 'ja'; // デフォルトは日本語
    const titleKey = to.meta.titleKey;
    const defaultTitle = langData[queryLang].defaultTitle;
    const pageTitle = titleKey
      ? langData[queryLang][titleKey.split('.')[0]][titleKey.split('.')[1]]
      : defaultTitle;

    document.title = pageTitle ? pageTitle + ' | ' + defaultTitle : defaultTitle;
  }
});

export default router;
